import React from "react"
// import { Link } from "gatsby"
// import classNames from "classnames"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"
import { parseFaqLine, renderFaqSegments } from "../utils/fqa"
import data from "../json/fqa.json"
import st from "./css/fqa.module.scss"

const FqaPage = function ({ isMobile }) {
  if (typeof document !== "undefined") {
    isMobile = document.documentElement.clientWidth <= 1140
  }
  return (
    <Layout cur="/fqa/" stickyHeader>
      <SEO
        title="酷课约课系统常见问答"
        keywords={["帮助文档", "酷课帮助", "常见问题", "酷课问答"]}
        description="关于酷课约课软件的常见问题，包括售前、售后使用上的各种问题解答。"
      />

      <div className={st.wrapper}>
        <div className={st.content}>
          {data.map((v, i) => (
            <section className={st.block} key={i}>
              <i id={`fqa-${i}`} className="g-link-tag"></i>
              <h4>{v.title}</h4>
              <ul>
                {v.content.map((item, itemIndex) => {
                  const parsed = parseFaqLine(item)
                  return (
                    <li
                      key={`${i}-${itemIndex}`}
                      className={parsed.isNote ? st.note : undefined}
                    >
                      {renderFaqSegments(
                        parsed.segments,
                        `fqa-${i}-${itemIndex}`,
                        {
                          inlineCode: st.inlineCode,
                        }
                      )}
                    </li>
                  )
                })}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default FqaPage
